// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__37dkD","detailsBorder":"styles_detailsBorder__1-kIX"};